import { List } from "immutable";
import * as M from "../../models";

export interface AdminAbstractTypeState {
    types: List<M.Abstract.AbstractTypeEdit>;
    loadingType: M.Generic.ItemLoadingState;
    loadingTypes: boolean;
    subscribedInvitationUpdates: List<M.Abstract.InvitationEmailStatusUpdate>;
}

export const initialAdminAbstractTypeState: AdminAbstractTypeState = {
    types: List(),
    loadingType: {},
    loadingTypes: true,
    subscribedInvitationUpdates: List(),
};



// WEBPACK FOOTER //
// ./src/store/adminAbstractType/AdminAbstractTypeState.ts